// 消息列表
<template>
  <div class="sld_msg_list">
    <div class="msg_title">{{listTitle}}</div>
    <div class="msg_con" v-if="noticeList.data && noticeList.data.length > 0">
      <div class="msg_con_top flex_row_between_center">
        <el-checkbox v-model="checkedAll">{{ L["全选"] }}</el-checkbox>
        <div class="msg_con_right flex_row_start_center">
          <div
            class="msg_del flex_row_center_center cursor_pointer"
            @click="delMsg()"
          >
            <img src="@/assets/msg/msg_del.png" alt="" />
            <span>{{ L["删除"] }}</span>
          </div>
          <div
            class="msg_read flex_row_center_center cursor_pointer"
            @click="readMsg"
          >
            <img src="@/assets/msg/msg_read.png" alt="" />
            <span>{{ L["标记已读"] }}</span>
          </div>
        </div>
      </div>
      <div class="msg_list">
        <div
          class="msg_list_pre"
          v-for="(noticeItem, noticeIndex) in noticeList.data"
          :key="noticeIndex"
        >
          <p class="msg_pre_time">{{ noticeItem.msgSendTime }}</p>
          <div class="msg_pre">
            <div class="msg_pre_title flex_row_between_center">
              <el-checkbox
                v-model="noticeItem.checked"
                class="pre_title_left"
                @change="noticeChecked()"
                >{{ noticeItem.tplName }}</el-checkbox
              >
              <el-popconfirm
                :confirmButtonText="L['确定']"
                :cancelButtonText="L['取消']"
                icon="el-icon-info"
                iconColor="red"
                :title="L['确定删除这条消息吗？']"
                @confirm="delMsg(noticeItem.receiveId)"
              >
                <template #reference
                  ><i
                    class="iconfont icon-ziyuan51 pre_title_right cursor_pointer"
                  ></i
                ></template>
              </el-popconfirm>
            </div>
            <!-- 	消息状态：0--未读，1--已读，2--删除 -->
            <div class="msg_content flex_row_between_center">
              <div class="msg_content_left flex_row_start_start">
                <span class="msg_tips" v-if="noticeItem.msgState == 0"></span>
                <p :class="{ active: noticeItem.msgState == 1 }">
                  {{ noticeItem.msgContent }}
                </p>
              </div>
              <div
                class="msg_content_right cursor_pointer"
                @click="goMsgDetail(noticeItem)"
              >
                {{ L["查看详情 >"] }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="flex_row_end_center sld_pagination sld_page_bottom"
          v-if="
            noticeData.data &&
            noticeData.data.pagination &&
            noticeData.data.pagination.total
          "
        >
          <el-pagination
            @prev-click="handlePrevCilickChange"
            @next-click="handleNextCilickChange"
            @current-change="handleCurrentChange"
            v-model:currentPage="current"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="noticeData.data.pagination.total"
            :hide-on-single-page="true"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <SldCommonEmpty v-if="!noticeList.data || (noticeList.data && noticeList.data.length == 0)" totalWidth="900" totalHeight="300" style="color:#666" :tip="L['暂时没有消息！']"/>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, reactive, ref, watchEffect } from "vue";
import { ElMessage } from "element-plus";
import { useRoute, useRouter } from "vue-router";
import SldCommonEmpty from "../../components/SldCommonEmpty"
export default {
  components:{
    SldCommonEmpty
  },
  setup() {
    const { proxy } = getCurrentInstance();
    const route = useRoute();
    const router = useRouter();
    const L = proxy.$getCurLanguage();
    const current = ref(1);
    const pageSize = ref(10);
    const noticeList = reactive({ data: [] }); //消息列表
    const checkedAll = ref(false); //全选是否选中
    const noticeData = reactive({ data: {} }); //消息数据
    const receiveIds = ref(""); //被选中的id集
    const curTplTypeCode = ref("msg_all"); //消息nav当前的项的tplTypeCode,默认为msg_all，消息列表全部
    const listTitle = ref('消息列表')
    onMounted(() => {
      curTplTypeCode.value = route.query.curTplTypeCode;
      getMsglist();
    });
    //监听路由是否变化
    router.beforeEach((to, from, next) => {
      if (to.query.curTplTypeCode) {
        curTplTypeCode.value = to.query.curTplTypeCode;
        if(curTplTypeCode.value == 'msg_all'){
          listTitle.value = L['消息列表'];
        }else if(curTplTypeCode.value == 'system_news'){
          listTitle.value = L['系统消息']
        }else if(curTplTypeCode.value == 'order_news'){
          listTitle.value = L['订单消息']
        }else if(curTplTypeCode.value == 'assets_news'){
          listTitle.value = L['资产消息']
        }else if(curTplTypeCode.value == 'after_sale_news'){
          listTitle.value = L['售后消息']
        }
        checkedAll.value = false; //是否全选置为默认值
      }
      getMsglist();
      next();
    });
    //获取消息列表
    const getMsglist = () => {
      let params = {};
      if (curTplTypeCode.value == "msg_all") {
        params = {
          pageSize: pageSize.value,
          current: current.value,
        };
      } else {
        params = {
          pageSize: pageSize.value,
          current: current.value,
          tplType: curTplTypeCode.value,
        };
      }
      proxy.$get("v3/msg/front/msg/msgList", params).then((res) => {
        if (res.state == 200) {
          let result = res.data;
          noticeData.data = result;
          noticeList.data = result.list;
          noticeList.data.map((noticeItem) => {
            noticeItem.checked = false;
          });
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    //监听
    watchEffect(() => {
      //全选状态是否选中
      if (checkedAll.value == true) {
        noticeList.data.map((noticeItem) => {
          noticeItem.checked = true;
        });
      } else {
        noticeList.data.map((noticeItem) => {
          noticeItem.checked = false;
        });
      }
    });
    //消息状态处理
    const noticeChecked = () => {
      let noCheckList = [];
      noCheckList = noticeList.data.filter(
        (noticeItem) => noticeItem.checked == false
      );
      if (noCheckList.length > 0) {
        checkedAll.value = false;
      } else {
        checkedAll.value = true;
      }
    };
    //上一页
    const handlePrevCilickChange = () => {
      current.value--;
      getMsglist();
    };
    //下一页
    const handleNextCilickChange = () => {
      current.value++;
      getMsglist();
    };
    //当前页
    const handleCurrentChange = () => {
      getMsglist();
    };
    //选中的id集
    const checkReceiveID = () => {
      let checkList = [];
      checkList = noticeList.data.filter(
        (noticeItem) => noticeItem.checked == true
      );
      let receiveIdsData = [];
      checkList.map((checkItem) => {
        receiveIdsData.push(checkItem.receiveId);
      });
      receiveIds.value = receiveIdsData.join(",");
    };
    //删除消息
    const delMsg = (receiveId) => {
      let params = {};
      if (receiveId) {
        params = {
          receiveIds: receiveId,
        };
      } else {
        checkReceiveID();
        params = {
          receiveIds: receiveIds.value,
        };
      }
      if(receiveIds.value || receiveId){
        proxy.$post("v3/msg/front/msg/del", params).then((res) => {
          if (res.state == 200) {
            ElMessage.success(res.msg);
            getMsglist();
            proxy.$getUserInfo();
          } else {
            ElMessage.error(res.msg);
          }
        });
      }else{
        ElMessage.error(L['请先选择要操作的消息！'])
      }

    };
    //标为已读
    const readMsg = () => {
      checkReceiveID();
      let params = {
        receiveIds: receiveIds.value,
      };
      if(receiveIds.value){
        proxy.$post("v3/msg/front/msg/read", params).then((res) => {
          if (res.state == 200) {
            ElMessage.success(res.msg);
            getMsglist();
            proxy.$getUserInfo();
          } else {
            ElMessage.error(res.msg);
          }
        });
      }else{
        ElMessage.error(L['请先选择要操作的消息！'])
      }
    };
    //消息跳转
    const goMsgDetail = (noticeItem) => {
      let msgLinkInfo = JSON.parse(noticeItem.msgLinkInfo);
      let curNotice = []; //当前消息
      curNotice = noticeList.data.filter((item=>item.receiveId == noticeItem.receiveId))
      if(curNotice && curNotice.length > 0){
        curNotice[0].checked = true;
        readMsg();
      }
      if (msgLinkInfo.type == "order_news") {
        // 商品出库提醒  || 付款成功提醒	进入订单详情
        router.push({
          path: "/member/order/detail",
          query: {
            orderSn: msgLinkInfo.orderSn,
          },
        });
      } else if (msgLinkInfo.type == "balance_change") {
        //余额变动提醒	进入我的钱包
        router.push({
          path: "/member/balance",
        });
      } else if (msgLinkInfo.type == "coupon_news") {
        //优惠券过期提醒	进入我的优惠券
        router.push({
          path: "/member/coupon",
        });
      } else if (
        msgLinkInfo.type == "return_news" ||
        msgLinkInfo.type == "refund_news"
      ) {
        //售后提醒 return_news(退货退款)  refund_news（仅退款 ）	进入我的售后列表  （afsSn）
        router.push({
          path: "/member/order/aftersales",
        });
      } else if (msgLinkInfo.type == "integral_change") {
        //积分变动提醒 进入我的积分
        router.push({
          path: "/member/recharge",
        });
      }
    };
    return {
      current,
      pageSize,
      noticeList,
      checkedAll,
      noticeChecked,
      noticeData,
      handlePrevCilickChange,
      handleNextCilickChange,
      handleCurrentChange,
      delMsg,
      receiveIds,
      readMsg,
      curTplTypeCode,
      L,
      goMsgDetail,
      listTitle
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../style/base.scss";
@import "../../style/iconfont.css";
@import "../../style/msgList.scss";
</style>
